import { render, staticRenderFns } from "./horizontalbar-page.vue?vue&type=template&id=3654d56d&"
import script from "./horizontalbar-page.vue?vue&type=script&lang=js&"
export * from "./horizontalbar-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports